<template>
  <v-container fluid>
    <PaginatedTable
      id="movimentacoes-ficha"
      ref="table"
      title="Movimentações"
      :headers="cabecalho"
      :data-fetcher="indexar"
      sort-by="id"
      sort-desc
    >
      <template #item.nome_cliente="{item}">
        <RouterLink
          :to="{ name: 'pagina_cliente', params: { id: item.id_cliente } }"
        >
          {{ item.nome_cliente }}
        </RouterLink>
      </template>

      <template v-slot:advancedFilters="{ advancedFilters, refresh, clear }">
        <v-chip-group>
          <v-chip @click="clear()">
            <v-icon small>mdi-filter-off</v-icon>
            Limpar
          </v-chip>

          <AdvancedFilterChip
            label="Valores"
            :active="
              advancedFilters.value_mode !== 'tudo' &&
                !!advancedFilters.value_mode
            "
          >
            <v-radio-group
              v-model="advancedFilters.value_mode"
              @change="refresh()"
            >
              <v-radio value="tudo" label="Tudo"></v-radio>
              <v-radio value="debito" label="Somente débitos"></v-radio>
              <v-radio value="receita" label="Somente créditos"></v-radio>
            </v-radio-group>
          </AdvancedFilterChip>
        </v-chip-group>
      </template>
    </PaginatedTable>
  </v-container>
</template>

<script>
import PaginatedTable from "@/components/server/PaginatedTable.vue";
import AdvancedFilterChip from "@/components/server/advancedFilters/AdvancedFilterChip.vue";
import { indexar } from "@/services/movimentacoes-ficha";

export default {
  components: {
    PaginatedTable,
    AdvancedFilterChip
  },

  data() {
    return {
      indexar,
      cabecalho: [
        {
          text: "Data",
          value: "created_at"
        },
        {
          text: "Cliente",
          value: "nome_cliente"
        },
        {
          text: "Valor",
          value: "amount"
        },
        {
          text: "Valor conta",
          value: "total_amount"
        },
        {
          text: "Responsável",
          value: "vendedor"
        }
      ]
    };
  },

  methods: {}
};
</script>
